import { cn } from '@/lib/utils';
import { Link, useLocation } from 'react-router-dom';
import { ContentDropdown } from './ContentDropdown';
const navigation = [
    { name: 'Create Books', href: '/create' },
    { name: 'Growth Autopilot', href: '/growth-autopilot' },
    { name: 'Marketplace', href: '/marketplace' },
    { name: 'Features', href: '/features' },
    { name: 'Pricing', href: '/pricing' },
    { name: 'Playbooks', href: '/self-publisher-playbooks' },
    { name: 'Partners', href: '/partners' },
];
interface DesktopNavProps {
    user: any;
}
function NavLink({ href, badge, children }: {
    href: string;
    badge?: string;
    children: React.ReactNode;
}) {
    const { pathname } = useLocation();
    const isActive = pathname === href || pathname.startsWith(href + '/');
    return (<Link to={href} aria-current={isActive ? 'page' : undefined} className={cn('relative inline-flex items-center gap-1.5 whitespace-nowrap rounded-lg px-2.5 py-2 text-[13px] font-medium transition-colors 2xl:px-3', isActive
            ? 'bg-secondary/10 font-semibold text-secondary'
            : 'text-slate-600 hover:bg-slate-100 hover:text-slate-900')}>
      <span>{children}</span>
      {badge && (<span className="rounded-full bg-secondary px-1.5 py-0.5 text-[9px] font-bold uppercase tracking-wide text-white">
          {badge}
        </span>)}
    </Link>);
}
export function DesktopNav({ user }: DesktopNavProps) {
    const { pathname } = useLocation();
    const isMarketplaceActive = pathname === '/marketplace' || pathname.startsWith('/marketplace/');
    return (<div className="flex shrink-0 items-center gap-3 2xl:gap-5">
      <Link to="/" aria-label="Bookstera home" className="mr-1 shrink-0"><img src="/lovable-uploads/bookstera-logo-nobg.webp" alt="Bookstera" className="h-7"/></Link>

      <>
          <nav aria-label="Main navigation" className="flex items-center gap-0.5">
            {navigation.map((item) => (<NavLink key={item.name} href={item.href} badge={item.href === '/growth-autopilot' ? 'NEW' : undefined}>
                {item.name}
              </NavLink>))}
          </nav>

          <nav className="flex items-center gap-2 text-sm font-medium text-slate-600" aria-label="Publishing Resources">
            <div className={isMarketplaceActive ? "hidden xl:block" : ""}><ContentDropdown /></div>
          </nav>
      </>
    </div>);
}
